/**
 *
 * @param {*} product
 *
 */

export const updateSavedProducts = (product) => {
  let productsLocal = JSON.parse(localStorage.getItem("products")) || {};
  let productsQtyLocal = JSON.parse(localStorage.getItem("productsQty")) || {};

  if (productsQtyLocal[product.id] !== undefined) {
    productsQtyLocal = {
      ...productsQtyLocal,
      [product.id]: productsQtyLocal[product.id] + 1,
    };
  } else {
    productsQtyLocal = { ...productsQtyLocal, [product.id]: 1 };
  }
  productsLocal = { ...productsLocal, [product.id]: product };

  localStorage.setItem("products", JSON.stringify(productsLocal));
  localStorage.setItem("productsQty", JSON.stringify(productsQtyLocal));
  return true;
};

export const removeProducts = () => {
  localStorage.setItem("products", "{}");
  localStorage.setItem("productsQty", "{}");
  return true;
};

export const addStonk = (portfolio, ticker) => {
  let updatedPortfolio = {};
  if (portfolio[ticker] !== undefined) {
    updatedPortfolio = { ...portfolio, [ticker]: { allocation: 0 } };
  } else {
    updatedPortfolio = { ...portfolio, [ticker]: { allocation: 0 } };
  }
  localStorage.setItem("portfolio", JSON.stringify(updatedPortfolio));
  return updatedPortfolio;
};

export const getPortfolioAllocation = () => {
  let alloc = 0;
  let localPortfolio = JSON.parse(localStorage.getItem("portfolio")) || {};
  for (const ticker in localPortfolio) {
    alloc += parseFloat(localPortfolio[ticker].allocation);
  }
  return alloc;
};

export const removeStonk = (portfolio, ticker) => {
  delete portfolio[ticker];
  localStorage.setItem("portfolio", JSON.stringify(portfolio));
  return portfolio;
};
